import { Button } from '@nazka/nazka.mapframe.components'
import { useQuery } from '@tanstack/react-query'

import { fetchAllMissionDataTypes, deleteMissionData } from '@services/data.service'

import './props-list.styl'

const parseJsonString = (value) => {
  if (typeof value !== 'string') return value

  try {
    return JSON.parse(value)
  } catch {
    return value
  }
}

const isPlainObject = (value) => {
  return value !== null && typeof value === 'object' && !Array.isArray(value)
}

const getOsmTags = (props) => {
  const osm = parseJsonString(props.osm)
  const tags = props.tags ?? (isPlainObject(osm) ? osm.tags : null)
  const parsedTags = parseJsonString(tags)

  return isPlainObject(parsedTags) ? parsedTags : null
}

function PropsList({ popup, props = {}, queryClient, userId }) {
  const excludedKeys = [
    '_id', 'id', 'icon', 'color', 'typeId', 'source', 'dataType', 'mission', 'private', 'owner', 'osm',
    'createdAt', 'updatedAt',
  ]
  const { id, source, owner, tags, osm, ...rest } = props
  const osmTags = getOsmTags({ tags, osm })
  const propertiesList = Object.entries({ id, source, ...(osmTags ? { ...osmTags } : rest) })
    .filter(([key, value]) => !excludedKeys.includes(key) && value)
    .map(([key, value]) => ({ key, value }))

  const { data: types } = useQuery({
    queryKey: ['types'],
    queryFn: () => fetchAllMissionDataTypes(),
  })

  const { icon, group, label } = types?.find(t => t.id === props.dataType) || {}

  return (
    <div className="props-list">
      <div className="props-list__header">
        <img
          src={`/img/icons/types/${group}/${icon}.svg`}
          className="props-list__header__icon"
          alt={`${icon || 'marker'}`}
        />
        <h3 className="props-list__header__title">
          {label}
        </h3>
      </div>
      <ul className="props-list__list">
        {propertiesList.map(({ key, value }) => (
          <li
            key={key}
            className="props-list__list__item"
          >
            <strong>
              {key}
              {': '}
            </strong>
            {value}
          </li>
        ))}
        {source !== 'custom' && (
          <li className="props-list__list__item">
            <strong>
              {'source: '}
            </strong>
            {source}
          </li>
        )}
        {source === 'custom' && (
          <li className="props-list__list__item">
            <strong>
              {'author_id: '}
            </strong>
            {userId}
          </li>
        )}
      </ul>
      {source === 'custom' && id && userId && owner === userId && (
        <Button
          className="props-list__button"
          onClick={async () => {
            try {
              popup?.remove()
              await deleteMissionData(id)
              await queryClient?.invalidateQueries({ queryKey: ['env'] })
              await queryClient?.invalidateQueries({ queryKey: ['breeding'] })
            } catch (error) {
              console.error('Error deleting mission data:', error)
            }
          }}
        >
          Delete custom data
        </Button>
      )}
    </div>
  )
}

export default PropsList
